// Бек разрешает единственный атрибут — span[data-wavy] (contract §7).
import { Mark, mergeAttributes } from '@tiptap/core'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    wavyUnderline: {
      toggleWavyUnderline: () => ReturnType
    }
  }
}

export const WavyUnderline = Mark.create({
  name: 'wavyUnderline',
  parseHTML() {
    return [{ tag: 'span[data-wavy]' }]
  },
  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes, { 'data-wavy': 'true' }), 0]
  },
  addCommands() {
    return {
      toggleWavyUnderline:
        () =>
        ({ commands }) =>
          commands.toggleMark(this.name),
    }
  },
})
